import { pipe } from 'fp-ts/function';
import { filterMap } from 'fp-ts/Array';
import { option } from 'fp-ts';
import { groupBy } from 'lodash/fp';
import { PortfolioRateOverview, PortfolioRateType } from '@mews-commander/data-access';

export const getBulkAddVoucherVariables = (selectedRows: PortfolioRateOverview[]) => {
    const noRowsSelected = selectedRows.length === 0;
    const isRatePublic = selectedRows.some(({ type }) => type === PortfolioRateType.Public);
    const isEmptyRateKey = selectedRows.some(({ key }) => key == null);

    const isVoucherAddDisabled = noRowsSelected || isRatePublic || isEmptyRateKey;

    const groupedSelectedRows = Object.entries(groupBy('propertyId', selectedRows)).map(([key, value]) => ({
        enterpriseId: key,
        rateKeys: pipe(
            value,
            filterMap(({ key: rateKey }) => (rateKey != null ? option.some(rateKey) : option.none))
        ),
    }));

    return {
        groupedSelectedRows,
        isVoucherAddDisabled,
    };
};
